import React from 'react';

const Form = ({ formData, handleInputChange, handleSubmit, clearInputs, isEditing }) => (
  <form onSubmit={handleSubmit} className="form-container">
    <div>
      <label>Name:</label>
      <input type="text" name="name" value={formData.name} onChange={handleInputChange} />
    </div>
    <div>
      <label>EMP_ID:</label>
      <input type="text" name="emp_id" value={formData.emp_id} onChange={handleInputChange} />
    </div>
    <div>
      <label>Designation:</label>
      <input type="text" name="designation" value={formData.designation} onChange={handleInputChange} />
    </div>
    <div>
      <label>Email:</label>
      <input type="email" name="email" value={formData.email} onChange={handleInputChange} />
    </div>
    <div>
      <label>Phone:</label>
      <input type="text" name="phone_no" value={formData.phone_no} onChange={handleInputChange} />
    </div>
    <div>
      <label>DoJ:</label>
      <input type="text" name="doj" value={formData.doj} onChange={handleInputChange} />
    </div>
    <div>
      <label>Department:</label>
      <input type="text" name="department" value={formData.department} onChange={handleInputChange} />
    </div>
    <button type="submit">{isEditing ? "Save Changes" : "Save"}</button>
    <button type="button" onClick={clearInputs}>Cancel</button>
  </form>
);

export default Form;